import { ProductTileOverlayProps } from "@faire/retailer-visitor-shared/features/MarketplaceItems/ComposableProductTile/__internal__/__internal__/components/ProductTileOverlay/productTileOverlayProps";
import {
  Overlay,
  OverlayStyle,
} from "@faire/retailer-visitor-shared/features/MarketplaceItems/Overlay/Overlay";
import { IProduct } from "@faire/web-api--source/indigofair/data/IProduct";
import React from "react";

export const ProductTileOverlay: React.FC<{
  data: ProductTileOverlayProps | undefined;
}> = ({ data }) => {
  if (!data) {
    return null;
  }
  const isUnavailable = data.state !== IProduct.State.FOR_SALE;
  const overlayStyle = () => {
    if (isUnavailable) {
      return OverlayStyle.UNAVAILABLE;
    } else {
      return OverlayStyle.DARKENING;
    }
  };

  if (data.includeContainer) {
    return (
      <div className="h-full w-full">
        <Overlay overlayStyle={overlayStyle()} />
      </div>
    );
  }
  return <Overlay overlayStyle={overlayStyle()} />;
};
